import { observer } from 'mobx-react-lite';

import { Table } from '@/components/table';
import { waybillWeighingAnalysisStore } from '@/stores';
import { getColumns } from './setup';

const store = waybillWeighingAnalysisStore;

export const WeighingAnalyses = observer(({ waybillId }: { waybillId: number }) => {
  const items = store.items;
  const columns = getColumns(waybillId);

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={[...items]}
      store={store}
      loading={store.loading}
      scroll={{ x: 1800 }}
      relId={waybillId}
    />
  );
});
